import { getSafeString } from '@y42/util/safe-string';
import { v4 as uuid } from 'uuid';
import { AbstractGitQueryEntity } from '../git/state/abstract-git-query-entity.service';
import { AbstractGitEntityState } from '../models/abstract-git-entity-state.model';
import { AbstractStoreModel } from '../models/abstract-store-model.model';

interface StoreModelWithName extends AbstractStoreModel {
  name: string;
}

export function getUniqueIdNamePair<State extends AbstractGitEntityState<StoreModelWithName>>({
  name,
  query,
}: {
  name: string;
  query: AbstractGitQueryEntity<State, StoreModelWithName>;
}) {
  const indexPattern = /^ *(\((\d+)\))?$/;
  const endIndexPattern = / *(\((\d+)\))?$/;
  const baseName = name.replace(endIndexPattern, '');

  // Get maximum index that is inside the parenthesis at the end of the entity name
  // from all entities matching the base name.
  const maxIndex = query
    .getAll()
    .filter((e) => e.name.startsWith(baseName) && e.name.slice(baseName.length).match(indexPattern))
    .map((e) => Number(e.name.slice(baseName.length).match(indexPattern)?.[2] ?? 0))
    .reduce((acc, curr) => Math.max(acc, curr), -1);

  const postfix = maxIndex > -1 ? ` (${maxIndex + 1})` : ``;

  return {
    name: `${baseName}${postfix}`,
    id: `${getSafeString(baseName)}-${uuid().slice(0, 8)}`,
  };
}
